"use client";

import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function DemoShowcase() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  return <section id="demo-showcase" ref={ref} className="bg-muted py-16 md:py-24" style={{
    opacity: isVisible ? 1 : 0,
    transform: isVisible ? "translateY(0)" : "translateY(20px)",
    transition: "opacity 200ms cubic-bezier(0.4, 0, 0.2, 1), transform 200ms cubic-bezier(0.4, 0, 0.2, 1)"
  }}>
      <div className="container mx-auto px-4 md:px-6">
        <div className="grid md:grid-cols-2 gap-8 md:gap-12 items-center">
          {}
          <div className="relative group">
            <div className="relative overflow-hidden rounded-lg shadow-medium aspect-video bg-secondary-light">
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1536499/img/ampkore_platform_demo_video_thumbnail.png" alt="AMPKORE platform demo video" className="w-full h-full object-cover" />
              <div className="absolute inset-0 bg-primary/10 opacity-0 group-hover:opacity-100 transition-opacity duration-[var(--duration-medium)]" />
              <div className="absolute inset-0 border-2 border-primary opacity-0 group-hover:opacity-100 transition-opacity duration-[var(--duration-medium)] rounded-lg" style={{
              animation: isVisible ? "pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite" : "none"
            }} />
            </div>
          </div>

          {}
          <div className="flex flex-col gap-6">
            <div className="space-y-4">
              <h2 className="text-3xl md:text-4xl font-bold text-foreground">
                See AMPKORE in Action
              </h2>
              <p className="text-foreground-muted-light text-lg leading-relaxed">
                Watch how AMPKORE transforms construction project management with AI-powered insights. Our platform monitors project vitals in real-time, detects scope gaps before they become costly issues, and optimizes subcontractor performance—all while maintaining 95% accuracy in scope gap detection.
              </p>
              <p className="text-foreground-muted-light leading-relaxed">
                Discover how our dedicated AI agents—PAM, SAM, BEN, VIC, and ART—work together to keep your projects on track, compliant, and within budget. Experience the future of construction management with secure Egnyte integration and enterprise-grade reliability.
              </p>
            </div>

            <div>
              <Button asChild size="lg" className="hover-lift">
                <Link to="#contact">
                  Schedule a Demo
                </Link>
              </Button>
            </div>
          </div>
        </div>
      </div>
    </section>;
}